import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Yahoo: React.FC<IconProps> = ({ size, style, color }) => {
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width={size ?? '20'} height={size ?? '21'} fill="none" viewBox="0 0 20 21" data-testid="yahoo-icon">
      <path
        fill={color || '#6000d3'}
        fillRule="evenodd"
        d="m-.024 5.16 4.36 11.667-1.569 4.204h3.83L12.406 5.16h-3.81L6.23 11.952 3.888 5.16Zm10.518 9.125c0 1.456.998 2.657 2.343 2.657 1.386 0 2.425-1.247 2.425-2.749 0-1.479-.999-2.657-2.343-2.657-1.386 0-2.425 1.27-2.425 2.75zM15.697.031 11.866 10.52h4.279L19.975.03Z"
      />
    </svg>
  );
};

export default Yahoo;
